module.exports = __webpack_public_path__ + "img/error-v3.fe101a0.png";